import { Component } from '@opten/compiler/metadata/component';
import { HttpErrorResponse } from '../httpclient/httpclient';
import { HttpStatusCodes } from '../httpclient/status-codes';
import { SignUpNew } from '../models/signup';
import { accountService, localizationService } from '../shop/shop-context';
import { AccountBase, AccountBaseOptions } from './account-base';

@Component({ className: 'js-shop-sign-up-new' })
export class SignUpNewComponent extends AccountBase {
	options: AccountBaseOptions = {
		selectors: {
			submitButton: 'js-shop-sign-up-new__submit'
		},
		disabled: '--disabled'
	};

	private _languageId: string;
	private _salutationId: HTMLInputElement;
	private _firstName: HTMLInputElement;
	private _lastName: HTMLInputElement;
	private _email: HTMLInputElement;
	private _telephone: HTMLInputElement;
	private _companyName: HTMLInputElement;
	private _street: HTMLInputElement;
	private _zip: HTMLInputElement;
	private _location: HTMLInputElement;
	private _accessfor: Node[];

	protected renderModel: {
		isGuest: boolean;
		submitSuccess?: boolean;
		submitError?: boolean;
		errorStatus?: string;
	};

	onInit(): void {
		super.onInit();
		localizationService.getAllLanguages().subscribe(languages => {
			const currentLanguage = localizationService.getCurrentLanguage();
			this._languageId = languages.find(o => o.isoCode === currentLanguage).umbracoReference;
		});
		this._salutationId = this.formElement.elements.namedItem('unknownSalutationId') as HTMLInputElement;
		this._firstName = this.formElement.elements.namedItem('unknownFirstName') as HTMLInputElement;
		this._lastName = this.formElement.elements.namedItem('unknownLastName') as HTMLInputElement;
		this._email = this.formElement.elements.namedItem('unknownEmail') as HTMLInputElement;
		this._telephone = this.formElement.elements.namedItem('unkownTelephone') as HTMLInputElement;
		this._companyName = this.formElement.elements.namedItem('unknownCompanyName') as HTMLInputElement;
		this._street = this.formElement.elements.namedItem('unkownStreet') as HTMLInputElement;
		this._zip = this.formElement.elements.namedItem('unkownZip') as HTMLInputElement;
		this._location = this.formElement.elements.namedItem('unknownLocation') as HTMLInputElement;
		this._accessfor = Array.from((this.formElement.elements.namedItem('unknownAccessfor') as RadioNodeList).values());

		// HINT: the order must match the order in html.
		// else you got a really confusing tab index order
		this.fieldsToValidate.push(
			this._salutationId,
			this._firstName,
			this._lastName,
			this._email,
			this._telephone,
			this._companyName,
			this._street,
			this._zip,
			this._location
		);
	}
	protected handleSubmit() {
		const signUp: SignUpNew = {
			salutationId: Number(this._salutationId.value),
			firstName: this._firstName.value,
			lastName: this._lastName.value,
			email: this._email.value,
			telephone: this._telephone.value,
			company: this._companyName.value,
			street: this._street.value,
			zip: this._zip.value,
			location: this._location.value,
			accessFor: this._accessfor.filter((el: HTMLInputElement) => el.checked).map((input: HTMLInputElement) => input.value)
		};

		accountService.registerPartner(signUp).subscribe(
			result => {
				if (result) {
					this.renderModel.submitError = false;
					this.renderModel.submitSuccess = true;
				} else {
					this.renderModel.submitError = true;
					this.renderModel.errorStatus = 'default';
				}
				this.renderer.render(this.formElement, this.renderModel, this);
			},
			(error: HttpErrorResponse) => {
				this.renderModel.submitError = true;
				switch (error.status) {
					case HttpStatusCodes.conflict:
						this.renderModel.errorStatus = 'conflict';
						break;
					case HttpStatusCodes.badRequest:
						this.renderModel.errorStatus = 'invalid';
						break;
					default:
						this.renderModel.errorStatus = 'default';
				}
				this.renderer.render(this.formElement, this.renderModel, this);
			}
		);
	}
}
